import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {isMobile} from 'react-device-detect';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import MainTitleComponent from '../Headline/MainTitleComponent';
import {images} from '../images/images';
import Config from '../../../../Config';

const CellcomDuErrorComponent = ({props}) => {
  if (props.data.errorReason == 'server_error') return null;
  const titleBold = 'רק רגע...';
  const description = 'להחלפת חבילה למנוי זה יש ליצור קשר עם נציג';

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }

    props.saveToHistory('msg');
  }, []);

  async function buttonFunction() {
    let content = await props.context.loadContentByPath(Config.lobbyUrl);
    props.context.navigateTo(content);
  }

  return (
    <div className='failure-container cellcomDu'>
      <MainTitleComponent title={'שינוי חבילת סלולר'} />
      <div className='d-flex justify-content-center'>
        <div className='bold main-text d-block'>
          <span dangerouslySetInnerHTML={{__html: titleBold}} />
        </div>
      </div>
      {description.trim() != '' && (
        <div className='d-flex justify-content-center text-center'>
          <div className='description fs-36'>
            <span dangerouslySetInnerHTML={{__html: description}} />
          </div>
        </div>
      )}

      <div className='d-flex failure-call-button-container justify-content-center'>
        <div className='message-text text-center'>
          {isMobile ? (
            <span className={`asBtn text-center d-block`}>
              <a href={'tel:*'+ window.Config.technicalSupportPhone}>
                <Image src={images.call} alt='call' className='ml-2' />
                <span>חייגו לנציג שירות {window.Config.technicalSupportPhone}</span>
              </a>
            </span>
          ) : (
            <div className='d-flex justify-content-center align-items-center'>
              <Image src={images.call} alt='call' style={{flexShrink: 0}} />
              <span className='pr-2'> דברו איתנו ב-{window.Config.technicalSupportPhone}</span>
            </div>
          )}
        </div>
      </div>
      <div className='d-flex justify-content-center'>
        <div className='btn-wrapper'>
          <BtnSubmit formid='failure-screen' onclick={() => buttonFunction()} text='חזרה לאיזור האישי'></BtnSubmit>
        </div>
      </div>
    </div>
  );
};

export default CellcomDuErrorComponent;
